import React from "react";

import Heading from "components/heading";

import VideoPlayer from "components/video-player";

import HeroSection from "../../hero-section";

const title = "Enerflo Made the Investment So You Don’t Have To";

const Investment = () => (
  <div className="bg-gray-100">
    <HeroSection title={title}>
      <div className="grow flex flex-col items-center">
        <HeroSection.Content className="w-full md:text-center mb-16">
          <HeroSection.Header>
            <Heading tag="h2">{title}</Heading>
          </HeroSection.Header>
        </HeroSection.Content>
        <HeroSection.Content className="w-full flex flex-col text-left lg:flex-row lg:items-center gap-x-10 gap-y-14">
          <div className="flex-1 space-y-6 max-w-2xl mx-auto lg:max-w-none">
            <div className="space-y-4">
              <p className="text-lg">
                Building world-class reporting isn’t easy. It takes time, resources, and serious expertise.
              </p>
              <p className="text-lg">Most solar companies hit roadblocks like:</p>
            </div>
            <ul className="list-disc list-outside space-y-1 ml-4">
              <li>
                <strong>Extra Software</strong> → More cost, more maintenance
              </li>
              <li>
                <strong>Data Cleanup</strong> → Standardizing names and values
              </li>
              <li>
                <strong>Data Pipelines</strong> → Pulling from multiple sources
              </li>
              <li>
                <strong>Expertise</strong> → Hiring data analysts to build reports
              </li>
              <li>
                <strong>Business Evolution</strong> → Keeping reporting relevant as you grow
              </li>
            </ul>

            <strong className="inline-block">Enerflo does the heavy lifting—so you don’t have to.</strong>
          </div>

          <figure className="flex-1">
            <VideoPlayer url="https://www.youtube.com/watch?v=uj-FYN1aMoQ" className="max-w-2xl mx-auto" />
            <figcaption className="text-center mt-2 text-sm text-gray-500 italic">
              Watch a Demo: See Enerflo’s New Reporting Suite in Action!
            </figcaption>
          </figure>
        </HeroSection.Content>
      </div>
    </HeroSection>
  </div>
);

export default Investment;
